import { Amplify } from 'aws-amplify'

let configured = false

const normalizeDomain = (value) => {
  if (!value) return ''
  try {
    const url = new URL(value)
    return url.host
  } catch {
    return value.replace(/^https?:\/\//i, '').replace(/\/+$/, '')
  }
}

const normalizeRedirects = (value) => {
  if (!value) return []
  const raw = Array.isArray(value) ? value : String(value).split(',')
  return raw
    .map((entry) => String(entry).trim())
    .filter(Boolean)
}

const absolutizeRedirects = (redirects, origin) => {
  if (!origin) return redirects
  return redirects.map((redirect) => {
    if (redirect.startsWith('/')) {
      return `${origin}${redirect}`
    }
    return redirect
  })
}

const withFallbackRedirect = (redirects, origin, fallbackPath) => {
  if (redirects.length) return redirects
  if (!origin || !fallbackPath) return []
  const normalized = fallbackPath.startsWith('/') ? fallbackPath : `/${fallbackPath}`
  return [`${origin}${normalized}`]
}

export const configureAmplify = () => {
  if (configured) return

  const region = process.env.GATSBY_COGNITO_REGION
  const userPoolId = process.env.GATSBY_COGNITO_USER_POOL_ID || process.env.COGNITO_USER_POOL_ID
  const userPoolClientId = process.env.GATSBY_COGNITO_APP_CLIENT_ID
  const domain = normalizeDomain(process.env.GATSBY_COGNITO_DOMAIN)
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const redirectSignIn = withFallbackRedirect(
    absolutizeRedirects(
      normalizeRedirects(process.env.GATSBY_COGNITO_REDIRECT_URI),
      origin
    ),
    origin,
    '/auth/callback'
  )
  const redirectSignOut = withFallbackRedirect(
    absolutizeRedirects(
      normalizeRedirects(process.env.GATSBY_COGNITO_SIGNOUT_URI),
      origin
    ),
    origin,
    '/institutional/login/'
  )

  const oauth = domain && redirectSignIn.length
    ? {
        domain,
        scopes: ['openid', 'email', 'profile'],
        redirectSignIn,
        redirectSignOut: redirectSignOut.length ? redirectSignOut : redirectSignIn,
        responseType: 'code'
      }
    : undefined

  Amplify.configure({
    Auth: {
      Cognito: {
        region,
        userPoolId,
        userPoolClientId,
        loginWith: oauth ? { oauth } : undefined
      }
    },
    ssr: true
  })

  configured = true
}
